import { gql } from '@apollo/client';
import Fragments from './fragments';
import CommonFragments from 'features/common/fragments';

export const FINANCIAL_PRODUCT_WARRANTY_UPDATED = gql`
  subscription financialProductWarrantyUpdated {
    financialProductWarrantyUpdated {
      financialProductWarranty {
        ...financialProductWarrantyEditItem
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.financialProductWarrantyEditItem}
  ${CommonFragments.messageHeaders}
`;


export const  FINANCIAL_PRODUCT_WARRANTY_FILTER_UPDATED = gql`
  subscription financialProductWarrantyFilterUpdated($leasingFinancialProductXWarrantyId: Int!) {
    financialProductWarrantyFilterUpdated(leasingFinancialProductXWarrantyId: $leasingFinancialProductXWarrantyId) {
        financialProductWarranty {
            leasingFinancialProductXWarrantyId
            productId
            warrantyTypeId
            quantity
            quantityTypeId
            mandatory
            genericFilterTemplateId
            templateName
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;